import {h, Component} from 'preact'
import {DropdownSelectizeGroup} from '../dropdown/DropdownSelectize'

export interface Category {
  categoryId: number,
  categoryName: string
}

export interface ParentCategory {
  groupName: string,
  categories?: Array<Category>
}

export interface ParentCategoryWithCategories {
  groupName: string,
  categories: Array<Category>
}

interface Props {
  categories: Array<ParentCategory>,
  selectedCategoryId?: number,
  onUpdate: (value: number) => void
}

export default class CategorySelector extends Component<Props> {
  render (props: Props) {
    const {categories, selectedCategoryId} = props
    function hasCategories(c: ParentCategory): c is ParentCategoryWithCategories {
      return !!c.categories
    }

    return <DropdownSelectizeGroup
      class='qa-category-select'
      placeholder='Select category ...'
      selectedValue={selectedCategoryId}
      onUpdate={this.props.onUpdate}
      optgroup={categories
        .filter(hasCategories)
        .map(group => {
          return {
            label: group.groupName,
            items: group.categories.map(item => {
              return {
                value: item.categoryId,
                label: item.categoryName
              }
            })
          }
        })} />
  }
}
